export default __webpack_public_path__ + "static/media/kitchen4-afterF-2048w.4a5a2f5e.png";